import { Button, Paper, Stack, type SxProps, Typography } from "@mui/material";
import Tooltip from '../Tooltip/Tooltip';
import React, { useState } from "react";
import { useText } from "../../main.tsx";
import type {PowerGoal} from "../../types/solar";

type Props = {
    currentGoal: PowerGoal;
    availableGoals: PowerGoal[];
    onGoalChange: (powerGoal: PowerGoal) => void;
};

const goalSxProps: SxProps = {
    flex: 1,
    py: 2.5,
    borderRadius: 2.5,
    fontSize: { xs: 12, sm: 16 },
};

const selectedGoalSxProps: SxProps = {
    backgroundColor: "#ff9d00",
    color: "#00031f",
    fontWeight: 600,
    "&:hover": {
        backgroundColor: "#ff9d00",
    },
};

const unselectedGoalSxProps: SxProps = {
    backgroundColor: "transparent",
    fontWeight: 400,
    "&:hover": {
        backgroundColor: "rgba(0,0,0,0.04)",
    },
};

const GoalSelection: React.FC<Props> = ({ currentGoal, availableGoals, onGoalChange }) => {
    const [selectedGoal, setSelectedGoal] = useState(currentGoal);

    const { t } = useText();

    function handleGoalChange(newPowerGoal: PowerGoal) {
        onGoalChange(newPowerGoal);
        setSelectedGoal(newPowerGoal);
    }

    return (
        <Stack direction="column" spacing={1}>
            <Typography variant="h2">
                {t('funnel.wizard.goalSelection.title')}
                <Tooltip text={t('funnel.wizard.goalSelection.tooltip')} />
            </Typography>

            <Paper
                sx={{
                    p: 1,
                    borderRadius: 2.5,
                    border: "1px solid rgba(0,3,31,0.4)",
                    backgroundColor: "rgba(255,255,255,0.8)",
                    backdropFilter: "blur(25px)",
                }}
            >
                <Stack
                    direction="row" spacing={0} sx={{
                    hyphens: "auto",
                    overflowWrap: "break-word",

                }}
                >
                    {availableGoals.map((option) => (
                        <Button
                            key={option.id}
                            onClick={() => handleGoalChange(option)}
                            sx={{
                                ...goalSxProps,
                                ...(option.id === selectedGoal.id ? selectedGoalSxProps : unselectedGoalSxProps)
                            }}
                        >
                            <div dangerouslySetInnerHTML={{ __html: option.formattedLabel }} />
                        </Button>
                    ))}
                </Stack>
            </Paper>
        </Stack>
    );
};

export default GoalSelection;
